export const CART_DETAILS_GET_REQUEST = 'CART_DETAILS_GET_REQUEST';
export const CART_DETAILS_GET_ERROR = 'CART_DETAILS_GET_ERROR';
